module.exports = __webpack_public_path__ + "static/media/twelveSaffron@2x.4b27dd3a.jpg";